import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import NavbarShopy from './navbarShopy/navbarShopy';
import SendClientPage from '../dropShipingInterface/SendClientPage/SendClientShop';
import SendClientBulkPage from '../dropShipingInterface/SendClientPage/SendClientBulkShop';
import AgregarProductoShopify from './shopifyInventario/agregarProductoShopify';
import { 
  Table, 
  Button, 
  Modal, 
  Select, 
  Alert, 
  Card, 
  Row, 
  Col, 
  Statistic, 
  Input, 
  Space, 
  Tag, 
  Tooltip,
  Typography 
} from 'antd';
import { 
  ShoppingCartOutlined, 
  CheckCircleOutlined, 
  ClockCircleOutlined, 
  DollarOutlined, 
  SearchOutlined,
  UserOutlined 
} from '@ant-design/icons';
import 'antd/dist/antd.css'; // Importa los estilos de antd
import { useNavigate } from 'react-router-dom';
import './Shopify.css';

const { Option } = Select;
const { Title } = Typography;

const ShopSubscription = () => {
  const [mostrarEnvios, setMostrarEnvios] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(null);
  const [ordersData, setOrdersData] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState(ordersData);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [stats, setStats] = useState({
    total: 0,
    pagados: 0,
    pendientes: 0,
    totalVentas: 0
  });
  const [filters, setFilters] = useState({
    estadoOrden: '',
    estadoFinanciero: '',
    estadoCumplimiento: '',
  });
  const [formData, setFormData] = useState({
    apiKey: '',
    password: '',
    sharedSecret: '',
    apiVersion: '',
    shopName: '', 
    codigo_sucursal: '',
    userId: ''
  });
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [mostrarEnviosMasivos, setMostrarEnviosMasivos] = useState(false);

  useEffect(() => {
    setFilteredOrders(ordersData);
    calculateStats(ordersData);
  }, [ordersData]);

  const calculateStats = (orders) => {
    const total = orders.length;
    const pagados = orders.filter(order => order.financial_status === 'paid').length;
    const pendientes = orders.filter(order => order.financial_status === 'pending').length;
    const totalVentas = orders.reduce((sum, order) => sum + parseFloat(order.total_price || 0), 0);

    setStats({
      total,
      pagados,
      pendientes,
      totalVentas
    });
  };

  const handleFilterByOrderStatus = (value) => {
    setFilters({ ...filters, estadoOrden: value });
  };

  const handleFilterByFinancialStatus = (value) => {
    setFilters({ ...filters, estadoFinanciero: value });
  };

  const handleFilterByFulfillmentStatus = (value) => {
    setFilters({ ...filters, estadoCumplimiento: value });
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  useEffect(() => {
    let result = ordersData;

    if (searchText) {
      result = result.filter(order =>
        order.product_title?.toLowerCase().includes(searchText.toLowerCase()) ||
        order.email?.toLowerCase().includes(searchText.toLowerCase()) ||
        order.order_number?.toString().includes(searchText) ||
        order.first_name?.toLowerCase().includes(searchText.toLowerCase()) ||
        order.last_name?.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    if (filters.estadoOrden) {
      result = result.filter(order => order.estado_order == filters.estadoOrden);
    }

    if (filters.estadoFinanciero) {
      result = result.filter(order => order.financial_status === filters.estadoFinanciero);
    }

    if (filters.estadoCumplimiento) {
      result = result.filter(order => order.fulfillment_status === filters.estadoCumplimiento);
    }

    setFilteredOrders(result);
  }, [searchText, filters, ordersData]);

  const navigate = useNavigate();

  // Función para verificar si la sucursal del usuario está suscrita
  const verificarSucursalUsuario = async () => {
    const userId = localStorage.getItem('usuario_id');
    if (!userId) {
      console.error('No se encontró el ID de usuario en localStorage');
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      userId: userId,
    }));

    try {
      const response = await axios.get(`https://integration.99envios.app/api/integration/shopify/v1/verificar-sucursal/${userId}`);
      const data = response.data;

      if (data.message ==
        'El suscriptor está activo.') {
        setIsSubscribed(true);
        setFormData((prevFormData) => ({
          ...prevFormData,
          sucursalId: data.codigo_sucursal
        }));
        localStorage.setItem('codigoSucursal', data.codigo_sucursal);
      } else {
        setIsSubscribed(false);
        setFormData((prevFormData) => ({
          ...prevFormData,
          codigo_sucursal: data.codigo_sucursal,
        }));
        Swal.fire({
          icon: 'warning',
          title: 'Sucursal no suscrita',
          text: 'Complete el formulario para suscribir la sucursal.',
        });
      }
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    }
  };

  // Función para obtener los datos de las órdenes de Shopify
  const fetchOrdersData = async () => {
    setLoading(true);
    try {
      const codigoSucursal = localStorage.getItem('codigoSucursal') || formData.codigo_sucursal;
      const response = await axios.get(`https://integration.99envios.app/api/ordersShopify/${codigoSucursal}`);
      // Ordenar las órdenes por ID de forma descendente antes de establecerlas
      const sortedOrders = response.data.sort((a, b) => Number(b.id) - Number(a.id));
      // Map the orders to include additional fields
      const mappedOrders = sortedOrders.map(order => ({
        ...order,
        first_name: order.customer?.first_name || '',
        last_name: order.customer?.last_name || '',
        phone: order.customer?.phone || '',
      }));
      setOrdersData(mappedOrders);
    } catch (error) {
      console.error('Error al obtener los datos de la API:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verificarSucursalUsuario();
  }, []);

  useEffect(() => {
    if (isSubscribed) {

      fetchOrdersData();
    }
  }, [isSubscribed]);

  // Función para manejar el envío del formulario de suscripción
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const codigoSucursal = localStorage.getItem('codigoSucursal') || formData.codigo_sucursal;
      await axios.post(`https://integration.99envios.app/api/integration/shopify/v1/integration/${codigoSucursal}`, formData);

      await Swal.fire({
        icon: 'success',
        title: 'Suscripción exitosa',
        text: 'La sucursal ha sido suscrita correctamente.',
      });

      // Recargar la página después de mostrar el mensaje de éxito
      window.location.reload();

    } catch (error) {
      console.error('Error al enviar los datos:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un error al registrar la suscripción.',
      });
    }
  };

  // Función para generar la guía
  const handleGenerateGuide = (order) => {
    // Buscar la orden completa en el array de ordersData
    const fullOrderData = ordersData.find(o => o.id === order.id);
    
    if (fullOrderData) {
      setSelectedOrder(fullOrderData);
      setMostrarEnvios(true);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se encontró la información completa de la orden',
      });
    }
  };

  const handleBulkGenerateGuide = () => {
    if (selectedOrders.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No hay órdenes seleccionadas',
        text: 'Por favor seleccione al menos una orden para generar las guías.',
      });
      return;
    }
    setMostrarEnviosMasivos(true);
  };

  const handleBulkDelete = async () => {
    const token = localStorage.getItem('token'); // Obtener el token del usuario
    
    if (!token) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se encontró el token de autenticación',
      });
      return;
    }

    // Confirmar antes de eliminar
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: `¿Deseas eliminar ${selectedOrders.length} órdenes seleccionadas?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        // Crear un array de promesas para todas las eliminaciones
        const deletePromises = selectedOrders.map(order => 
          axios.delete(`https://99envios.app/api/eliminar_orden_shopify/${order.id}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })
        );

        // Ejecutar todas las eliminaciones
        await Promise.all(deletePromises);

        Swal.fire(
          'Eliminado',
          'Las órdenes han sido eliminadas con éxito',
          'success'
        );

        // Actualizar la lista de órdenes
        fetchOrdersData();
        // Limpiar la selección
        setSelectedOrders([]);
      } catch (error) {
        console.error('Error al eliminar las órdenes:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un error al eliminar las órdenes',
        });
      }
    }
  };

  const rowSelection = {
  selectedRowKeys: selectedOrders.map(order => order.id),
  onChange: (_, selectedRows) => {
    if (selectedRows.length > 10) {
      Swal.fire({
        icon: 'warning',
        title: 'Límite alcanzado',
        text: 'Solo puedes seleccionar hasta 10 órdenes a la vez.',
      });
      return;
    }
    setSelectedOrders(selectedRows);
  },
  getCheckboxProps: (record) => ({
    disabled: selectedOrders.length >= 10 && !selectedOrders.some(o => o.id === record.id),
  }),
  onSelectAll: (selected, selectedRows, changeRows) => {
    if (selected) {
      // Solo selecciona los primeros 10 de la página actual
      setSelectedOrders(selectedRows.slice(0, 10));
    } else {
      setSelectedOrders([]);
    }
  }
};

  const getEstadoFinancieroColor = (estado) => {
    switch (estado?.toLowerCase()) {
      case 'paid':
        return 'success';
      case 'pending':
        return 'warning';
      case 'refunded':
        return 'error';
      default:
        return 'default';
    }
  };

  const getEstadoCumplimientoColor = (estado) => {
    switch (estado?.toLowerCase()) {
      case 'fulfilled':
        return 'success';
      case 'unfulfilled':
        return 'warning';
      default:
        return 'default';
    }
  };

  // Definición de las columnas para la tabla de antd
  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 60,
      sorter: (a, b) => Number(a.id) - Number(b.id),
      defaultSortOrder: 'descend',
    },
    {
      title: 'Orden',
      dataIndex: 'order_number',
      key: 'order_number',
      width: 80,
      render: (text) => (
        <span style={{ fontWeight: 500, color: '#1890ff' }}>#{text}</span>
      ),
    },
    {
      title: 'Cliente',
      key: 'cliente',
      width: 150,
      render: (_, record) => (
        <Tooltip title={record.email}>
          <div>
            <div style={{ fontWeight: 500 }}>{record.first_name} {record.last_name}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>{record.email}</div>
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Producto',
      dataIndex: 'product_title',
      key: 'product_title',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
      render: (text) => (
        <Tooltip placement="topLeft" title={text}>
          <span style={{ fontWeight: 500 }}>{text}</span>
        </Tooltip>
      ),
    },
    {
      title: 'Precio Unit.',
      dataIndex: 'product_price',
      key: 'product_price',
      width: 100,
      render: (price) => (
        <span style={{ color: '#1890ff', fontWeight: 600 }}>
          ${parseFloat(price).toLocaleString()}
        </span>
      ),
    },
    {
      title: 'Cant.',
      dataIndex: 'product_quantity',
      key: 'product_quantity',
      width: 60,
      align: 'center',
      render: (quantity) => (
        <span style={{ 
          background: '#f0f0f0', 
          padding: '2px 8px', 
          borderRadius: '12px',
          fontWeight: 500 
        }}>
          {quantity}
        </span>
      ),
    },
    {
      title: 'Total',
      dataIndex: 'total_price',
      key: 'total_price',
      width: 100,
      render: (total) => (
        <span style={{ color: '#52c41a', fontWeight: 600 }}>
          ${parseFloat(total).toLocaleString()}
        </span>
      ),
    },
    {
      title: 'Estado Pago',
      dataIndex: 'financial_status',
      key: 'financial_status',
      width: 110,
      render: (status) => {
        const statusMap = {
          'paid': 'Pagado',
          'pending': 'Pendiente',
          'refunded': 'Reembolso'
        };
        return (
          <Tag color={getEstadoFinancieroColor(status)} style={{ fontWeight: 500 }}>
            {(statusMap[status] || status)?.toUpperCase()}
          </Tag>
        );
      }
    },
    {
      title: 'Estado Envío',
      dataIndex: 'fulfillment_status',
      key: 'fulfillment_status',
      width: 110,
      render: (status) => {
        const statusMap = {
          'fulfilled': 'Enviado',
          'unfulfilled': 'Pendiente'
        };
        return (
          <Tag color={getEstadoCumplimientoColor(status)} style={{ fontWeight: 500 }}>
            {(statusMap[status] || status)?.toUpperCase()}
          </Tag>
        );
      }
    },
    {
      title: 'Fecha',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 100,
      defaultSortOrder: 'descend',
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (text) => {
        const date = new Date(text);
        const formattedDate = date.toLocaleDateString('es-CO', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        return <span style={{ color: '#666' }}>{formattedDate}</span>;
      }
    },
    {
      title: 'Guía',
      key: 'actions',
      fixed: 'right',
      width: 80,
      render: (_, record) => (
        <Button 
          type="primary" 
          size="small"
          onClick={() => handleGenerateGuide(record)}
          style={{ borderRadius: '6px' }}
        >
          Crear
        </Button>
      ),
    }
  ];

  const [isModalVisible, setIsModalVisible] = useState(false);
  
    const showModal = () => {
      setIsModalVisible(true);
    };
  
    const handleCancel = () => {
      setIsModalVisible(false);
    };

  if (isSubscribed) {
    return (
      <>
        <Modal
          open={mostrarEnvios}
          title="Generar Guía de Envío"
          onCancel={() => setMostrarEnvios(false)}
          footer={null}
          width={1000}
        >
          {selectedOrder && (
            <SendClientPage selectedOrder={selectedOrder} />
          )}
        </Modal>

        <Modal
          open={mostrarEnviosMasivos}
          title="Generar Guías de Envío Masivamente"
          onCancel={() => setMostrarEnviosMasivos(false)}
          footer={null}
          width="95vw"
          style={{ top: 20, padding: 0, maxWidth: '100vw' }}
          bodyStyle={{ minHeight: '80vh', padding: 0 }}
        >
          {selectedOrders.length > 0 && (
            <SendClientBulkPage selectedOrders={selectedOrders} />
          )}
        </Modal>

        <NavbarShopy title="Órdenes de Shopify" />
        <div className='shopify-misPedidos'>
          {/* Estadísticas */}
          <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col xs={24} sm={12} md={6}>
              <Card>
                <Statistic
                  title="Total Órdenes"
                  value={stats.total}
                  prefix={<ShoppingCartOutlined style={{ color: '#1890ff' }} />}
                  valueStyle={{ color: '#1890ff' }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card>
                <Statistic
                  title="Pagadas"
                  value={stats.pagados}
                  prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
                  valueStyle={{ color: '#52c41a' }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card>
                <Statistic
                  title="Pendientes"
                  value={stats.pendientes}
                  prefix={<ClockCircleOutlined style={{ color: '#faad14' }} />}
                  valueStyle={{ color: '#faad14' }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card>
                <Statistic
                  title="Total Ventas"
                  value={stats.totalVentas}
                  prefix={<DollarOutlined style={{ color: '#52c41a' }} />}
                  valueStyle={{ color: '#52c41a' }}
                  formatter={(value) => `$${value?.toLocaleString()}`}
                />
              </Card>
            </Col>
          </Row>

          {/* Botones superiores */}
          <Card style={{ marginBottom: 16 }}>
            <div className='top-actions-container-shopify'>
              <div className="articulos-container">
                <AgregarProductoShopify />
              </div>
              <Alert 
                message={
                  <>
                    Para conocer el funcionamiento de Shopify, consulta el siguiente video instructivo:{" "}
                    <Button type="link" onClick={showModal} style={{ padding: 0 }}>
                      Ver video aquí.
                    </Button>
                  </>
                }
                type="info"
                showIcon
                style={{ marginTop: 0 }}
              />
            </div>
          </Card>

          {/* Filtros y búsqueda */}
          <Card className="filters-card" style={{ marginBottom: 16 }}>
            <Row gutter={[16, 16]} align="middle">
              <Col xs={24} sm={12} md={8}>
                <Input
                  placeholder="Buscar por producto, email, cliente, orden..."
                  prefix={<SearchOutlined />}
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  allowClear
                />
              </Col>
              <Col xs={24} sm={12} md={4}>
                <Select
                  style={{ width: '100%' }}
                  placeholder="Estado Guía"
                  onChange={handleFilterByOrderStatus}
                  allowClear
                >
                  <Option value="">Todos</Option>
                  <Option value="0">Sin Imprimir</Option>
                  <Option value="1">Impreso</Option>
                </Select>
              </Col>
              <Col xs={24} sm={12} md={4}>
                <Select
                  style={{ width: '100%' }}
                  placeholder="Estado Pago"
                  onChange={handleFilterByFinancialStatus}
                  allowClear
                >
                  <Option value="">Todos</Option>
                  <Option value="paid">Pagado</Option>
                  <Option value="pending">Pendiente</Option>
                  <Option value="refunded">Reembolsado</Option>
                </Select>
              </Col>
              <Col xs={24} sm={12} md={4}>
                <Select
                  style={{ width: '100%' }}
                  placeholder="Estado Envío"
                  onChange={handleFilterByFulfillmentStatus}
                  allowClear
                >
                  <Option value="">Todos</Option>
                  <Option value="fulfilled">Cumplido</Option>
                  <Option value="unfulfilled">No cumplido</Option>
                </Select>
              </Col>
              <Col xs={24} sm={12} md={4}>
                <Space>
                  <span style={{ color: '#666', fontSize: '14px' }}>
                    Mostrando {filteredOrders.length} de {ordersData.length} órdenes
                  </span>
                </Space>
              </Col>
            </Row>
          </Card>
          <Modal
            title="Instructivos de Shopify"
            visible={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            destroyOnClose={true}
            width="100vh"
            style={{ top: 20 }}
            bodyStyle={{ padding: 0 }}
          >
            <div style={{ padding: '20px' }}>
              <h3>Video 1: Instructivo General</h3>
              <div style={{ position: 'relative', paddingBottom: '65%', height: 0, overflow: 'hidden', marginBottom: '30px' }}>
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/Jpp4RNhVcx0?si=pF2MJE_HW0D5h"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                ></iframe>
              </div>

              <h3>Video 2: Guía de Uso</h3>
              <div style={{ position: 'relative', paddingBottom: '65%', height: 0, overflow: 'hidden', marginBottom: '30px' }}>
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/ocyQGJszW58?si=AePGw2iGE7j7YYXL"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                ></iframe>
              </div>

              <h3>Video 3: Tutorial Avanzado</h3>
              <div style={{ position: 'relative', paddingBottom: '65%', height: 0, overflow: 'hidden' }}>
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/9P0dck5xq4Q?si=kKTv2VegZ2A1InRa"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                ></iframe>
              </div>
            </div>
          </Modal>

          {/* Título y tabla con scroll y botón fijo */}
          <div className={`bulk-actions ${selectedOrders.length > 0 ? 'has-selected' : ''}`}>
            {selectedOrders.length > 0 && (
              <span className="selection-counter">
                <span role="img" aria-label="check">✓</span>
                {selectedOrders.length} {selectedOrders.length === 1 ? 'orden seleccionada' : 'órdenes seleccionadas'}
              </span>
            )}
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                type="primary"
                onClick={handleBulkGenerateGuide}
                disabled={selectedOrders.length === 0}
                icon={<span role="img" aria-label="document">📄</span>}
              >
                Generar {selectedOrders.length > 0 ? `${selectedOrders.length} Guías` : 'Guías Masivamente'}
              </Button>
              <Button
                type="primary"
                danger
                onClick={handleBulkDelete}
                disabled={selectedOrders.length === 0}
                icon={<span role="img" aria-label="delete">🗑️</span>}
              >
                Eliminar {selectedOrders.length} {selectedOrders.length === 1 ? 'Orden' : 'Órdenes'}
              </Button>
            </div>
          </div>

          {/* Tabla */}
          <Card className="table-card">
            <Table
              rowSelection={{
                ...rowSelection,
                columnWidth: 48,
              }}
              columns={columns}
              dataSource={filteredOrders}
              loading={loading}
              rowKey="id"
              pagination={{
                pageSize: 15,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} de ${total} órdenes`,
                pageSizeOptions: ['10', '15', '25', '50'],
              }}
              scroll={{ x: 1500 }}
              locale={{ emptyText: 'No hay órdenes disponibles' }}
              size="middle"
            />
          </Card>
        </div>
      </>
    );
  }

  return (
    <>
      <NavbarShopy title="Integración a tienda" />
      <div className='shopify-misPedidos'>
        <div className="shopify-container">
          <Card className="form-card">
            <Title level={2} style={{ textAlign: 'center', marginBottom: '32px', color: '#1890ff' }}>
              Formulario de Integración a tienda
            </Title>
            <form onSubmit={handleSubmit} className="form-container">
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <div className="form-group">
                    <label>Código Sucursal:</label>
                    <Input
                      type="text"
                      name="codigo_sucursal"
                      value={formData.codigo_sucursal}
                      onChange={(e) => setFormData({ ...formData, codigo_sucursal: e.target.value })}
                      required
                      size="large"
                    />
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="form-group">
                    <label>API Key:</label>
                    <Input
                      type="text"
                      name="apiKey"
                      value={formData.apiKey}
                      onChange={(e) => setFormData({ ...formData, apiKey: e.target.value })}
                      required
                      size="large"
                    />
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="form-group">
                    <label>Password:</label>
                    <Input.Password
                      name="password"
                      value={formData.password}
                      onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                      required
                      size="large"
                    />
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="form-group">
                    <label>Shared Secret:</label>
                    <Input
                      type="text"
                      name="sharedSecret"
                      value={formData.sharedSecret}
                      onChange={(e) => setFormData({ ...formData, sharedSecret: e.target.value })}
                      required
                      size="large"
                    />
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="form-group">
                    <label>API Version:</label>
                    <Input
                      type="text"
                      name="apiVersion"
                      value={formData.apiVersion}
                      onChange={(e) => setFormData({ ...formData, apiVersion: e.target.value })}
                      required
                      size="large"
                    />
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="form-group">
                    <label>Shop Name:</label>
                    <Input
                      type="text"
                      name="shopName"
                      value={formData.shopName}
                      onChange={(e) => setFormData({ ...formData, shopName: e.target.value })}
                      required
                      size="large"
                    />
                  </div>
                </Col>
                <Col xs={24}>
                  <div className="button-container">
                    <Button 
                      type="primary" 
                      htmlType="submit" 
                      size="large"
                      style={{ 
                        width: '100%',
                        height: '50px',
                        fontSize: '16px',
                        fontWeight: '600'
                      }}
                    >
                      Registrar Integración
                    </Button>
                  </div>
                </Col>
              </Row>
            </form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ShopSubscription;
